/**
 * Report types for the report registry and hub
 */

// =============================================================================
// Report Domain and Access Types
// =============================================================================

export type ReportDomain = 'licensing' | 'users' | 'cases' | 'data-usage' | 'infrastructure'

export type ReportAccess = 'internal' | 'external'

// =============================================================================
// Report Metadata
// =============================================================================

export interface ReportMetadata {
  /** Unique report identifier */
  id: string
  /** Human-readable report name */
  name: string
  /** Description of what the report shows */
  description: string
  /** Domain this report belongs to */
  domain: ReportDomain
  /** Access level (internal admin or external client) */
  access: ReportAccess
  /** Lucide icon name for UI display */
  icon: string
  /** Frontend route path for this report */
  path: string
  /** Whether the report supports query parameters */
  queryable: boolean
  /** Whether the report supports CSV/export */
  exportable: boolean
}

// =============================================================================
// API Query Parameters
// =============================================================================

export interface ListReportsParams {
  /** Filter by domain */
  domain?: ReportDomain
  /** Filter by access level */
  access?: ReportAccess
}

// =============================================================================
// Domain Labels for UI
// =============================================================================

export const DOMAIN_LABELS: Record<ReportDomain, string> = {
  licensing: 'Licensing',
  users: 'Users',
  cases: 'Cases',
  'data-usage': 'Data Usage',
  infrastructure: 'Infrastructure',
}

export const ACCESS_LABELS: Record<ReportAccess, string> = {
  internal: 'Internal',
  external: 'External',
}
